function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M256 512c141 0 256-115 256-256S397 0 256 0 0 115 0 256s115 256 256 256zm-43-262c0-23 19-42 43-42s43 19 43 42v114c0 24-19 43-43 43s-43-19-43-43zm0-122c0-24 19-43 43-43s43 19 43 43-19 43-43 43-43-19-43-43z"
}));